import { render, staticRenderFns } from "./BidPreview.vue?vue&type=template&id=77b53b0c&scoped=true&"
import script from "./BidPreview.vue?vue&type=script&lang=js&"
export * from "./BidPreview.vue?vue&type=script&lang=js&"
import style0 from "./BidPreview.vue?vue&type=style&index=0&id=77b53b0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b53b0c",
  null
  
)

export default component.exports